import { CommonPageWrapper, HeadingWrapper } from 'admin/components/wrappers';
import { PageMainLabel } from 'app/components/SHLabel';
import styled from 'styled-components';
import SchoolTeamLeaderPointTable from './SchoolTeamLeaderPointTable';
import LeaderPointTeamHeaderCell from 'admin/pages/TeamIndividual/components/TeamRiderListing/Cells/LeaderPointTeamHederCell';
import TeamNameLabelCell from 'admin/pages/TeamIndividual/components/TeamRiderListing/Cells/TeamNameLabelCell';
import { LeaderPointCell } from 'admin/pages/TeamIndividual/components/TeamRiderListing/Cells/LeaderPointCell';
import { LeaderPoint, LeaderPointWrapper, ShowScoreBoardClasses } from 'services/openapi';
import { leaderPointDataConvertion, teamHeaderObject } from '../static';
import { TableSkeletonLoader } from 'app/components/TableSkeletonLoader';
import React from 'react';
import YedaLogo from 'app/components/admin/sidebar/assets/img/yeda-logo.png';

type Props = { showLeaderPointList: LeaderPoint | undefined; loading: boolean };

const LeaderPointPage = ({ showLeaderPointList, loading }: Props) => {
  const headerClassListJuniorHighSchoolteam =
    showLeaderPointList?.juniorHighSchoolteam?.classes;
  const headerClassListSeniorHighSchoolteam =
    showLeaderPointList?.seniorHighSchoolteam?.classes;
  const updatedJuniorHeaderCells = [
    teamHeaderObject,
    ...(typeof headerClassListJuniorHighSchoolteam === 'object' &&
    headerClassListJuniorHighSchoolteam !== null
      ? headerClassListJuniorHighSchoolteam
      : []),
  ];
  const updatedSeniorHeaderCells = [
    teamHeaderObject,
    ...(typeof headerClassListSeniorHighSchoolteam === 'object' &&
    headerClassListSeniorHighSchoolteam !== null
      ? headerClassListSeniorHighSchoolteam
      : []),
  ];
  const mappedSeniorHeaderCells = updatedSeniorHeaderCells?.map(headerCell => {
    const fieldName = headerCell?.code?.toLowerCase();
    return {
      field: fieldName,
      width: fieldName === 'team' ? '200' : '180',
      headerCell: props => (
        <LeaderPointTeamHeaderCell title={headerCell?.name!} />
      ),
      cell: e => {
        const cellComponent = ['team'].includes(fieldName!) ? (
          <TeamNameLabelCell
            e={e}
            value={
              fieldName === 'team'
                ? e.dataItem.teamName
                : fieldName === 'total_point'
                ? e.dataItem.total === 0 ||
                  e.dataItem.total === '' ||
                  e.dataItem.total === null 
                    ?"-"
                    : e.dataItem.total 
                : fieldName === 'final_placing'
                ? e.dataItem.finalPlacing === 0 ||
                  e.dataItem.finalPlacing === '' ||
                  e.dataItem.finalPlacing === null
                  ?"-"
                  :e.dataItem.finalPlacing
                : ''
            }
          />
        ) : (
          <LeaderPointCell
            riderName={e.dataItem[`${headerCell?.code!}_NAME`]}
            backNo={e.dataItem[`${headerCell?.code!}_BACKNO`]}
          />
        );

        return cellComponent;
      },
    };
  });
  const mappedJuniorHeaderCells = updatedJuniorHeaderCells?.map(headerCell => {
    const fieldName = headerCell?.code?.toLowerCase();
    return {
      field: fieldName,
      width: fieldName === 'team' ? '200' : '180',
      headerCell: props => (
        <LeaderPointTeamHeaderCell title={headerCell?.name!} />
      ),
      cell: e => {
        const cellComponent = ['team'].includes(fieldName!) ? (
          <TeamNameLabelCell
            e={e}
            value={
              fieldName === 'team'
                ? e.dataItem.teamName
                : fieldName === 'total_point'
                ? e.dataItem.total === 0 ||
                  e.dataItem.total === '' ||
                  e.dataItem.total === null 
                    ?"-"
                    : e.dataItem.total
                : fieldName === 'final_placing'
                ? e.dataItem.finalPlacing === 0 ||
                  e.dataItem.finalPlacing === '' ||
                  e.dataItem.finalPlacing === null
                  ?"-"
                  :e.dataItem.finalPlacing
                : ''
            }
          />
        ) : (
          <LeaderPointCell
            riderName={e.dataItem[`${headerCell?.code!}_NAME`]}
            backNo={e.dataItem[`${headerCell?.code!}_BACKNO`]}
          />
        );

        return cellComponent;
      },
    };
  });
  return (
    <>
      <ScreenOnlyWrapper>
        <StyledCommonPageWrapper>
          {loading ? (
            <TableSkeletonLoader rowContent={8} width={100} headingWidth={80} />
          ) : (
            <>
              <TitleCardWrapper>
                <HeadingWrapper className="heading-wrapper">
                  <PageMainLabel className="label-wrapper">
                    Senior High School Team
                  </PageMainLabel>
                </HeadingWrapper>
              </TitleCardWrapper>
              <SchoolTeamLeaderPointTable
                data={leaderPointDataConvertion(
                  showLeaderPointList?.seniorHighSchoolteam?.results,
                )}
                columns={mappedSeniorHeaderCells}
              />
              <TitleCardWrapper className="junior-high-school-team-wrapper">
                <HeadingWrapper className="heading-wrapper">
                  <PageMainLabel className="label-wrapper">
                    Junior High School Team
                  </PageMainLabel>
                </HeadingWrapper>
              </TitleCardWrapper>
              <SchoolTeamLeaderPointTable
                data={leaderPointDataConvertion(
                  showLeaderPointList?.juniorHighSchoolteam?.results,
                )}
                columns={mappedJuniorHeaderCells}
              />
            </>
          )}
        </StyledCommonPageWrapper>
      </ScreenOnlyWrapper>
      <LeaderPointPrintTable showLeaderPointList={showLeaderPointList} />
    </>
  );
};

export default LeaderPointPage;

// ---------- Print-only components ----------

const LeaderPointPrintSection: React.FC<{
  title: string;
  wrapper: LeaderPointWrapper | undefined;
}> = ({ title, wrapper }) => {
  const classes: ShowScoreBoardClasses[] = wrapper?.classes ?? [];
  const rows = leaderPointDataConvertion(wrapper?.results) ?? [];

  return (
    <>
      <tr className="section-title-row">
        <td colSpan={classes.length + 1}>{title}</td>
      </tr>
      <tr className="col-header-row">
        <th>Team</th>
        {classes.map((cls, i) => (
          <th key={i}>{cls.name}</th>
        ))}
      </tr>
      {rows.map((team, idx) => (
        <tr key={idx} className={idx % 2 === 1 ? 'row-alt' : ''}>
          <td>{team.teamName}</td>
          {classes.map((cls, i) => {
            const name = team[`${cls.code}_NAME`];
            const backNo = team[`${cls.code}_BACKNO`];
            return (
              <td key={i}>
                {name || backNo
                  ? `${name ?? ''}${backNo ? ` (${backNo})` : ''}`
                  : '-'}
              </td>
            );
          })}
        </tr>
      ))}
    </>
  );
};

const LeaderPointPrintTable: React.FC<{
  showLeaderPointList: LeaderPoint | undefined;
}> = ({ showLeaderPointList }) => (
  <PrintTableWrapper>
    <div className="print-logo">
      <img src={YedaLogo} alt="YEDA" />
    </div>
    <table className="print-table">
      <tbody>
        <LeaderPointPrintSection
          title="Senior High School Team"
          wrapper={showLeaderPointList?.seniorHighSchoolteam}
        />
        <LeaderPointPrintSection
          title="Junior High School Team"
          wrapper={showLeaderPointList?.juniorHighSchoolteam}
        />
      </tbody>
    </table>
  </PrintTableWrapper>
);

// ---------- Styled Components ----------

const ScreenOnlyWrapper = styled.div`
  @media print {
    display: none;
  }
`;

const PrintTableWrapper = styled.div`
  display: none;
  @media print {
    display: block;
    width: 100%;
  }
  .print-logo {
    display: none;
    @media print {
      display: block;
      margin-bottom: 10px;
      img {
        width: 85px;
        height: auto;
      }
    }
  }
  .print-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 10px;
    font-family: 'Inter', Arial, sans-serif;
    color: #000;
    page-break-inside: auto;
  }
  .print-table th,
  .print-table td {
    border: 1px solid #ccc;
    padding: 3px 6px;
    text-align: left;
    vertical-align: middle;
  }
  .section-title-row td {
    background-color: #e7ecff;
    font-weight: 700;
    font-size: 12px;
    text-align: center;
    padding: 6px;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  .col-header-row th {
    background-color: #eaecf0;
    font-weight: 600;
    text-align: center;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  .row-alt td {
    background-color: #f7f9fc;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  tr {
    page-break-inside: avoid;
  }
`;
const StyledCommonPageWrapper = styled(CommonPageWrapper)`
  margin-bottom: 52px;
`;
const TitleCardWrapper = styled.div`
  &.junior-high-school-team-wrapper {
    margin-top: 54px;
  }
  margin-top: 5px;
  background-color: #e7ecff;
  .heading-wrapper {
    padding: 14px 0px 14px 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    .label-wrapper {
      font-family: 'Inter';
      font-size: 14px;
      font-weight: 600;
      line-height: 14.52px;
      color: #000000;
      margin: unset !important;
    }
  }
`;
